import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useGoogleLogin } from '@react-oauth/google';
import { useMsal } from '@azure/msal-react';
import './LoginModal.css';
import NotificationModal from "../../components/NotificationModal/NotificationModal";


// IMPORTA TUS IMÁGENES Y SVGS AQUÍ (Ajusta las rutas según tu proyecto)
import vistaRegistrate from './vista_registrate.jpg'; 
import vistaAccede from './vista_login.jpg'; 
import googleSvg from './google_logo.png'; 
import microsoftSvg from './microsoft_logo.png';

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost/backend_onelearning/api";

const LoginModal = ({ isOpen, onClose }) => {
    // 1. ESTADO DE PESTAÑAS ('login' o 'register')
    const [activeTab, setActiveTab] = useState('login');

    // 2. ESTADOS DE LOGIN
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    // 3. ESTADOS DE REGISTRO
    const [regNombre, setRegNombre] = useState("");
    const [regApellido, setRegApellido] = useState("");
    const [regCorreo, setRegCorreo] = useState("");
    const [regConfirmCorreo, setRegConfirmCorreo] = useState("");
    const [regPassword, setRegPassword] = useState("");
    const [regConfirmPassword, setRegConfirmPassword] = useState("");

    // NOTIFICACION MODAL
    const [isUpdateOpen, setUpdateOpen] = useState(false);

    // MENSAJES
    const [errorMsg, setErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");

    const { instance } = useMsal();

    // --- LÓGICAS DE OAUTH (Se mantienen igual) ---
    const loginMicrosoft = async () => {
        try {
            const loginResponse = await instance.loginPopup({ scopes: ["User.Read", "email"] });
            const tokenResponse = await instance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: loginResponse.account
            });
            sendToBackend({ provider: 'microsoft', token: tokenResponse.accessToken });
        } catch (error) {
            console.error(error);
            setErrorMsg("Error iniciando con Microsoft");
        }
    };

    const loginGoogle = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            sendToBackend({ provider: 'google', token: tokenResponse.access_token });
        },
        onError: error => setErrorMsg("No se pudo iniciar sesión con Google.")
    });

    const sendToBackend = async (userData) => {
        try {
            const response = await fetch(`${API_BASE}/auth/social_login.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(userData),
                credentials: 'include'
            });
            const result = await response.json();

            if (result.status === 'success') {
                setSuccessMsg(`¡Bienvenido ${result.user.first_name}!`);
                window.location.reload();
                setTimeout(() => { onClose(); }, 1500);
            } else {
                setErrorMsg(result.message);
            }
        } catch (error) {
            setErrorMsg("Error conectando con el servidor.");
        }
    };

    // --- LÓGICAS FORMULARIOS LOCALES ---
    const handleLocalLogin = async (e) => {
        e.preventDefault();
        setErrorMsg("");
        try {
            const response = await fetch(`${API_BASE}/auth/login_local.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
                credentials: 'include'
            });
            const result = await response.json();

            if (result.status === 'success') {
                setSuccessMsg(`¡Hola ${result.user.first_name}!`);
                setUpdateOpen(true); // Abrimos la modal de registro exitoso
                window.location.reload();
                setTimeout(() => { onClose(); }, 1500);
            } else {
                setErrorMsg(result.message);
            }
        } catch (error) {
            setErrorMsg("Error de conexión local.");
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setErrorMsg("");
        setSuccessMsg("");

        // Validaciones en el Frontend
        if (regCorreo !== regConfirmCorreo) {
            return setErrorMsg("Los correos no coinciden.");
        }
        if (regPassword !== regConfirmPassword) {
            return setErrorMsg("Las contraseñas no coinciden.");
        }
        
        // Validación de fuerza de contraseña
        const passRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;
        if (!passRegex.test(regPassword)) {
            return setErrorMsg("La contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial.");
        }

        try {
            const response = await fetch(`${API_BASE}/auth/register_local.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    first_name: regNombre,
                    last_name: regApellido,
                    email: regCorreo,
                    password: regPassword
                }),
                credentials: 'include'
            });
            
            const result = await response.json();

            if (result.status === 'success') {
                setSuccessMsg(result.message);
                setTimeout(() => { 
                    window.location.reload(); 
                }, 1500);
            } else {
                setErrorMsg(result.message);
            }
        } catch (error) {
            console.error(error);
            setErrorMsg("Error de conexión al intentar registrarse.");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay-split" onClick={onClose}>
            
            <div className="modal-container-split" onClick={(e) => e.stopPropagation()}>
                
                {/* Botón Cerrar flotante */}
                <button className="btn-close-split" onClick={onClose}>
                    <FaTimes />
                </button>

                {/* COLUMNA IZQUIERDA: IMAGEN DINÁMICA */}
                <div 
                    className="modal-left-image" 
                    style={{ 
                        backgroundImage: `url(${activeTab === 'login' ? vistaAccede : vistaRegistrate})` 
                    }}
                >
                </div>

                {/* COLUMNA DERECHA: CONTENIDO Y FORMULARIOS */}
                <div className="modal-right-content">
                    
                    {/* TABS (Pestañas) */}
                    <div className="modal-tabs">
                        <div 
                            className={`tab-item ${activeTab === 'register' ? 'active' : ''}`}
                            onClick={() => { setActiveTab('register'); setErrorMsg(""); }}
                        >
                            Regístrate
                        </div>
                        <div 
                            className={`tab-item ${activeTab === 'login' ? 'active' : ''}`}
                            onClick={() => { setActiveTab('login'); setErrorMsg(""); }}
                        >
                            Accede
                        </div>
                    </div>

                    {errorMsg && <div className="msg-box error">{errorMsg}</div>}
                    {successMsg && <div className="msg-box success">{successMsg}</div>}

                    {/* =========================================
                        VISTA: ACCEDE (LOGIN)
                    ========================================= */}
                    {activeTab === 'login' && (
                        <div className="tab-pane slide-in">
                            <form className="split-form" onSubmit={handleLocalLogin}>
                                
                                <div className="form-group">
                                    <label>Correo</label>
                                    <input 
                                        type="email" 
                                        value={email} 
                                        onChange={(e) => setEmail(e.target.value)} 
                                        required 
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label>Contraseña</label>
                                    <input 
                                        type="password" 
                                        value={password} 
                                        onChange={(e) => setPassword(e.target.value)} 
                                        required 
                                    />
                                </div>

                                <hr className="divider-teal" />

                                <div className="social-login-group">
                                    <button type="button" className="btn-social-svg" onClick={() => loginGoogle()}>
                                        <span className="social-text">Accede con</span> 
                                        <img src={googleSvg} alt="Google" className="icon-svg" />
                                    </button>
                                    <button type="button" className="btn-social-svg" style={{gap: '8px'}} onClick={() => loginMicrosoft()}>
                                        <span className="social-text">Accede con</span> 
                                        <img src={microsoftSvg} alt="Microsoft" className="icon-svg" />
                                    </button>
                                </div>

                                <button type="submit" className="btn-submit" style={{margin: '25px auto 0px auto'}}>Acceder</button>
                            </form>
                        </div>
                    )}

                    {/* =========================================
                        VISTA: REGÍSTRATE
                    ========================================= */}
                    {activeTab === 'register' && (
                        <div className="tab-pane slide-in">
                            <form className="split-form register-form" onSubmit={handleRegister}>
                                
                                <div className="form-grid-2-col">
                                    <div className="form-group">
                                        <label>Nombre</label>
                                        <input type="text" value={regNombre} onChange={(e)=>setRegNombre(e.target.value)} required />
                                    </div>
                                    <div className="form-group">
                                        <label>Apellido</label>
                                        <input type="text" value={regApellido} onChange={(e)=>setRegApellido(e.target.value)} required />
                                    </div>

                                    <div className="form-group">
                                        <label>Correo</label>
                                        <input type="email" value={regCorreo} onChange={(e)=>setRegCorreo(e.target.value)} required />
                                    </div>
                                    <div className="form-group">
                                        <label>Repite tu correo</label>
                                        <input type="email" value={regConfirmCorreo} onChange={(e)=>setRegConfirmCorreo(e.target.value)} required />
                                    </div>

                                    <div className="form-group">
                                        <label>Crea tu contraseña</label>
                                        <input type="password" value={regPassword} onChange={(e)=>setRegPassword(e.target.value)} required />
                                    </div>
                                    <div className="form-group">
                                        <label>Repite tu contraseña</label>
                                        <input type="password" value={regConfirmPassword} onChange={(e)=>setRegConfirmPassword(e.target.value)} required />
                                    </div>
                                </div>

                                <p className="disclaimer-form">
                                    * La contraseña debe tener una mayúscula, un número y un caracter especial
                                </p>

                                <div className="register-action-wrapper">
                                    <button type="submit" className="btn-submit-teal">Regístrate</button>
                                    <p className="disclaimer-bottom">
                                        * Disclaimer de uso de datos con responsabilidad blah blah blah
                                    </p>
                                </div>
                            </form>
                        </div>
                    )}

                </div>
            </div>
              
            <NotificationModal 
                isOpen={isUpdateOpen} 
                title="REGISTRO EXITOSO" 
                buttonText="Aceptar" 
                onClose={() => setUpdateOpen(false)} 
            />
        </div>

    );
};

export default LoginModal;